import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OrdersPage } from './orders';
import {NgxPaginationModule} from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';
import {FileUploadModule} from 'ng2-file-upload';

@NgModule({
  declarations: [
    OrdersPage,
  ],
  imports: [
    IonicPageModule.forChild(OrdersPage),
    NgxPaginationModule,
    FileUploadModule,
    TranslateModule.forChild()
  ],
})
export class OrdersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.module.ts